import { useContext, useEffect, useState } from "react";
import { callBackendApi } from "@/utils/common";
import HeadComponent from "@/components/HeadComponent";
import Avatar from "react-avatar";
import moment from "moment";
import ImageCompanyLogo from "@/components/ImageCompanyLogo";
import CompanyCard from "@/components/UserProfileComp/CompanyCard";
import ActivityCard from "@/components/UserProfileComp/ActivityCard";
import FavouritesCard from "@/components/UserProfileComp/FavouritesCard";
import { Form, Spinner } from "react-bootstrap";
import { BsCalendarEvent } from "react-icons/bs";
import { AppContext } from "@/pages/_app";
import Image from "next/image";
import ErrorStateImage from "../../../assets/Illustrations/stack empty state.svg";

const NumberOfPosts = 5;

const UserProfile = (props) => {
  const [error, setError] = useState(props.error);
  const [user, setUser] = useState(props.user);
  const [userStacks, setUserStacks] = useState(props.organizations?.stacks);
  const [userVendors, setUserVendors] = useState(props.organizations?.vendors);
  const [userPosts, setUserPosts] = useState([]);
  const [postCheckbox, setPostCheckbox] = useState(true);
  const [commentCheckbox, setCommentCheckbox] = useState(true);
  const [likeCheckbox, setLikeCheckbox] = useState(true);
  const [menuState, setMenuState] = useState("Activity");
  const [favouriteCompanies, setFavouriteCompanies] = useState(null);
  const [favouriteCompaniesLoading, setFavouriteCompaniesLoading] =
    useState(false);
  const [userPostsLoading, setUserPostsLoading] = useState(false);
  const postLimit = NumberOfPosts;
  const [postSkip, setPostSkip] = useState(0);
  const [userActivtiyCount, setUserActivtiyCount] = useState(0);
  const [postFilter, setPostFilter] = useState([
    "posted",
    "commented",
    "liked-post",
    "liked-reply",
  ]);
  const [loading, setLoading] = useState(false);
  const userOrgMembersCount = props.organizations?.userOrgMembersCount;

  const dateFormat = (date) => moment(date).format("MMM YYYY"); // mmm-dd-yyyy
  const { loggedInUser } = useContext(AppContext);
  /**
   * Fallback UI handling
   */
  if (error.status) {
    const errorMessage =
      error.errorMessage?.error === "User Not Found"
        ? "No User Found"
        : "Something Went Wrong";

    const errorDescription =
      error.errorMessage?.error === "User Not Found"
        ? "No items found, try finding something else..."
        : "Its seems like something went wrong..";

    return (
      <div className="m-auto d-flex justify-content-center align-items-center flex-column">
        <Image
          src={ErrorStateImage}
          width={700}
          height={300}
          className="mt-0"
        />
        <h5>{errorMessage}</h5>
        <p>{errorDescription}</p>
      </div>
    );
  }

  /**
   * @param number(pointer to skip the already rendering posts)
   * @returns object(user activity data)
   */
  const handleUserPosts = async (skip = 0) => {
    try {
      setUserPostsLoading(true);

      if (error.status === false) {
        const data = { query: { username: user.username } };
        const postRes = await callBackendApi({
          method: "post",
          url: "/community/user/posts",
          data: data,
          params: { limit: postLimit, filter: postFilter, skip: skip },
        });
        const userPostsData = postRes.data.data.userActivity;
        setUserActivtiyCount(postRes.data.data.count);
        setUserPostsLoading(false);
        return userPostsData;
      }

      setUserPostsLoading(false);
    } catch (error) {
      console.log(error);
      setUserPostsLoading(false);
    }
  };

  /**
   *
   * @param string(username of the current profile user)
   * @returns setFavouriteCompanies
   */
  const handleUserFavourites = async (username) => {
    setFavouriteCompaniesLoading(true);
    try {
      const companyRes = await callBackendApi({
        method: "get",
        url: `/like/user-vendor-likes/${username}`,
      });
      let companiesData = companyRes.data.data.map((item) => item.vendorId);

      if (loggedInUser) {
        const likeRes = await callBackendApi({
          method: "get",
          url: `/like/${loggedInUser.email}`,
        });
        const likeArr = likeRes.data.data.map((item) => item.vendorId);
        companiesData = companiesData.map((company) => {
          if (likeArr.includes(company._id)) {
            company.liked = true;
          } else {
            company.liked = false;
          }
          return company;
        });
      }
      setFavouriteCompanies(companiesData);
    } catch (error) {
      setError(error);
    }
    setFavouriteCompaniesLoading(false);
  };

  /**
   * @description onClick load more button => get more user posts by incresing the number of postSkip by 5
   */
  const handleLoadMore = async () => {
    const userPostsData = await handleUserPosts(postSkip);
    setPostSkip(postSkip + NumberOfPosts);
    const userPostsArr = userPosts.concat(userPostsData);
    setUserPosts(userPostsArr);
  };

  useEffect(async () => {
    setUser(props.user);
    setUserStacks(props.organizations?.stacks);
    setUserVendors(props.organizations?.vendors);
    handleUserFavourites(props.user?.username);
  }, [props.user]);

  useEffect(async () => {
    try {
      setLoading(true);
      const userPostsData = await handleUserPosts(postSkip);
      setPostSkip(postSkip + NumberOfPosts);
      const userPostsArr = userPosts.concat(userPostsData);
      setUserPosts(userPostsArr);
      handleUserFavourites(user.username);
      setLoading(false);
    } catch (error) {
      setFavouriteCompaniesLoading(false);
      setLoading(false);
      console.log(error);
    }
  }, []);

  useEffect(() => {
    handleFilter();
  }, [postCheckbox, commentCheckbox, likeCheckbox]);

  const hadleCommentCheckbox = () => {
    setCommentCheckbox((prev) => !prev);
  };

  const handlePostCheckbox = () => {
    setPostCheckbox((prev) => !prev);
  };

  const handleLikeCheckbox = () => {
    setLikeCheckbox((prev) => !prev);
  };

  useEffect(async () => {
    setPostSkip(NumberOfPosts);
    setLoading(true);
    const userPostsData = await handleUserPosts(0);
    setLoading(false);
    setUserPosts(userPostsData);
  }, [postFilter, user]);

  const handleFilter = () => {
    let filter = [];
    if (postCheckbox) {
      filter = [...filter, "posted"];
    }

    if (commentCheckbox) {
      filter = [...filter, "commented"];
    }

    if (likeCheckbox) {
      filter = [...filter, "liked-post", "liked-reply"];
    }

    setPostFilter(filter);
  };

  return (
    <>
      <HeadComponent
        title={"Modern  - Everything that you need to know !"}
        url={"https://www.moderndatastack.xyz"}
        description={
          "Resources and tools to help you build and operate a Modern Data Stack"
        }
      />
      {user && !error.status && (
        <>
          <div className="mds-bg-primary-muted">
            <div className="container">
              <div className="d-flex flex-column flex-md-row w-100 gap-4 py-5 justify-content-start align-items-center">
                {user.imageUrl ? (
                  <Image
                    alt="#"
                    layout="fixed"
                    className="mds-profile-border-radius"
                    src={user.imageUrl}
                    width={170}
                    height={170}
                  />
                ) : (
                  <Avatar
                    className="mds-profile-border-radius"
                    color="#F66640"
                    name={user.fullName}
                    size="170"
                  />
                )}
                <div className="d-flex flex-column gap-0 text-center justify-content-center align-items-center justify-content-md-start align-items-md-start">
                  <h1>{user.fullName}</h1>
                  <p className="text-muted mds-fs-lg">
                    @<span id="username">{user.username}</span>
                  </p>
                  <div className="mds-fs-5 d-flex gap-1 felx-row align-items-text">
                    <span>
                      <BsCalendarEvent className="mds-btn-icon mds-text-primary" />
                    </span>
                    <span className="text-muted">Joined On</span>
                    {dateFormat(user.createdAt)}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container d-flex flex-md-row flex-column w-100 py-md-5 py-3">
            <div className="d-flex flex-md-column flex-shrink-0 flex-row overflow-auto">
              {menuState === "Activity" && (
                <div
                  style={{ minWidth: "200px" }}
                  className="mds-border-muted mds-rounded-md m-3 p-3"
                >
                  <h4>Filters</h4>
                  <div className="d-flex flex-column gap-2">
                    <label className="mds-fs-5 d-flex">
                      <Form.Check
                        disabled={userPostsLoading}
                        size={50}
                        inline={true}
                        className="mds-checkbox"
                        type="checkbox"
                        checked={postCheckbox}
                        onChange={handlePostCheckbox}
                      />
                      <span>Posts</span>
                    </label>
                    <label className="mds-fs-5">
                      <Form.Check
                        disabled={userPostsLoading}
                        inline={true}
                        className="mds-checkbox"
                        type="checkbox"
                        checked={commentCheckbox}
                        onChange={hadleCommentCheckbox}
                      />
                      <span>Comments</span>
                    </label>
                    <label className="mds-fs-5">
                      <Form.Check
                        disabled={userPostsLoading}
                        inline={true}
                        className="mds-checkbox"
                        type="checkbox"
                        checked={likeCheckbox}
                        onChange={handleLikeCheckbox}
                      />
                      <span>Likes</span>
                    </label>
                  </div>
                </div>
              )}

              {userStacks.length === 0 && userVendors.length === 0 && (
                <div className="flex-grow-1 m-3 p-3"></div>
              )}

              {userStacks.length > 0 && (
                <div className="mds-border-muted mds-rounded-md m-3 p-3 d-flex flex-column gap-2">
                  <h4>Stacks</h4>
                  {userStacks.map((stack, index) => (
                    <CompanyCard
                      type="stacks"
                      key={index}
                      company={stack}
                      membersCount={userOrgMembersCount}
                    />
                  ))}
                </div>
              )}
              {userVendors.length > 0 && (
                <div className="mds-border-muted mds-rounded-md m-3 p-3 d-flex flex-column gap-2">
                  <h4>Companies</h4>
                  {userVendors.map((vendor, index) => (
                    <CompanyCard
                      type="vendors"
                      key={index}
                      company={vendor}
                      membersCount={userOrgMembersCount}
                    />
                  ))}
                </div>
              )}
            </div>
            <div
              style={{ minHeight: "600px" }}
              className="flex-grow-1 px-md-0 px-3"
            >
              <div className="d-flex justify-content-around text-muted align-items-center">
                <h4
                  onClick={() => setMenuState("Activity")}
                  style={{
                    width: "100%",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                  className={
                    (menuState === "Activity"
                      ? " mds-text-primary mds-border-primary border-4 "
                      : " mds-border-muted border-1 text-muted mds-fw-md ") +
                    "flex-1 pb-2 border-0 border-bottom "
                  }
                >
                  Activity
                </h4>
                <h4
                  style={{
                    width: "100%",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => setMenuState("Favourites")}
                  className={
                    (menuState === "Favourites"
                      ? " mds-text-primary mds-border-primary border-4 "
                      : " mds-border-muted border-1 text-muted mds-fw-md ") +
                    "flex-1 pb-2 border-0 border-bottom "
                  }
                >
                  Favourites
                </h4>
              </div>
              {menuState === "Activity" &&
                (loading ? (
                  <div className="btn d-flex h-100 mds-text-primary justify-content-center align-items-center">
                    <Spinner animation="border" size="lg" />
                  </div>
                ) : (
                  <ActivityCard
                    loading={userPostsLoading}
                    userPosts={userPosts}
                    user={user}
                    postsLeft={userActivtiyCount - postSkip}
                    handleLoadMore={handleLoadMore}
                  />
                ))}

              {menuState === "Favourites" &&
                (favouriteCompaniesLoading ? (
                  <div className="btn d-flex h-100 mds-text-primary justify-content-center align-items-center">
                    <Spinner animation="border" size="lg" />
                  </div>
                ) : (
                  <FavouritesCard companies={favouriteCompanies} />
                ))}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default UserProfile;

export const getServerSideProps = async (context) => {
  const err = { status: false, errorMessage: null };
  let user = null;
  let organizations = null;


  try {
    const userRes = await callBackendApi({
      method: "get",
      url: `/user/username/${context.query.id.toLowerCase()}`,
    });
    if (userRes) {
      user = userRes.data.data.user;
    }
  } catch (error) {
    err.status = true;
    if (error.response) {
      err.errorMessage = error.response.data.data;
    } else {
      err.errorMessage = error.message;
    }
    return {
      props: {
        error: err,
      },
    };
  }

  try {
    const userOrgRes = await callBackendApi({
      method: "get",
      url: "/organization/user-orgs",
      data: { query: { username: user.username } },
    });
    if (userOrgRes) {
      organizations = userOrgRes.data.data;
    }
  } catch (error) {
    err.status = true;
    err.errorMessage = error.message;
  }

  return {
    props: {
      user,
      error: err,
      organizations,
    },
  };
};
